import { useEffect, useState } from 'react';
import axios from 'axios';
import { endpoints } from '@/lib/axios/axios-global';

export type ControlPlaneMe = {
    id: number;
    email?: string;
    name?: string;
    is_super_admin: boolean;
    permissions: string[];
    environment: string;
};

export function useControlPlanePermissions() {
    const [me, setMe] = useState<ControlPlaneMe | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await axios.get(endpoints.controlPlane.me);
                if (!cancelled) setMe(res.data?.data ?? null);
            } catch {
                if (!cancelled) setMe(null);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const can = (permission: string) => {
        if (!me) return false;
        if (me.is_super_admin) return true;
        return me.permissions?.includes(permission);
    };

    return { me, loading, can, isSuperAdmin: !!me?.is_super_admin };
}
